import Image, { StaticImageData } from 'next/image';

import arrow_left from './images/arrow-left.png';
import arrow_right from './images/arrow-right.png';
export interface IPaging {
  page: number;
  next?: (page: number) => void;
  prev?: (page: number) => void;
  total: number;
  icon?: StaticImageData;
  activeIcon?: StaticImageData;
  textColor?: string;
}
export const Paging = (props: IPaging) => {
  const {
    page,
    next,
    prev,
    total,
    icon,
    activeIcon,
    textColor = '#323C46',
  } = props;
  const isMin = page <= 1;
  const isMax = page >= total;
  const normalIcon = icon || arrow_left;
  const actIcon = activeIcon || arrow_right;
  return (
    <div className="flex items-center">
      <Image
        src={isMin ? normalIcon : actIcon}
        alt=""
        className={`w-10 h-10 cursor-pointer ${isMin ? '' : 'rotate-180'}`}
        onClick={() => prev && prev(page - 1)}
      />

      <div className={`px-[1.37rem] text-sm font-400 flex text-${textColor}`}>
        <span>{page}</span>
        <span className=" ml-[0.12rem]">/ {total}</span>
      </div>
      <Image
        src={isMax ? normalIcon : actIcon}
        alt=""
        className={`w-10 h-10 cursor-pointer ${isMax ? 'rotate-180' : ''}`}
        // onClick={next}
        onClick={() => next && next(page + 1)}
      />
    </div>
  );
};
